import formatPrice from "../../../components/formatPrice";
import datetimeParser from "../../../components/datetimeParser";
import CopyData from "../../../components/CopyData";
import { Tag } from "antd";

const columns = [
	{
		title: "Status",
		dataIndex: "msr_wplywy_to_forward_ready",
		key: "msr_wplywy_to_forward_ready",
		width: "160px",
		render: (value) =>
			Number(value || 0) === 1 ? (
				<Tag color="green">GOTOWY</Tag>
			) : (
				<Tag color="orange">NIEGOTOWY</Tag>
			),
	},
	{
		title: "ID wpływu",
		dataIndex: "msr_wplywy_own_id",
		width: "160px",
		key: "msr_wplywy_own_id",
		render: (item) => (
			<div className="monospace">
				<CopyData item={`#${item}`} />#{item}
			</div>
		),
	},
	{
		title: "Kwota przekazu",
		dataIndex: "msr_przekazania_amount",
		key: "msr_przekazania_amount",
		width: "180px",
		render: (item) => (
			<div
				className="monospace"
				style={{
					fontSize: "14px",
					fontWeight: 700,
					textAlign: "right",
				}}
			>
				{formatPrice(item)} zł
			</div>
		),
	},
	{
		title: "Rachunek",
		dataIndex: "msr_bank_accounts_name",
		key: "msr_bank_accounts_name",
		render: (item, record) => (
			<div style={{ fontSize: "14px", fontWeight: 500 }}>
				<div>{record.msr_bank_accounts_name || "Brak danych"}</div>
				<div
					className="monospace"
					style={{ opacity: 0.8 }}
				>
					{record.msr_bank_accounts_number || ""}
				</div>
			</div>
		),
	},
	{
		title: "Data wpływu",
		dataIndex: "msr_wplywy_date_in",
		key: "msr_wplywy_date_in",
		width: "140px",
		render: (item) => (
			<div style={{ fontSize: "14px", fontWeight: 500 }}>
				{item && item !== "null"
					? datetimeParser(item, "YYYY-MM-DD")
					: "Brak"}
			</div>
		),
	},
	{
		title: "Opis z banku",
		dataIndex: "msr_wplywy_bank_desc",
		key: "msr_wplywy_bank_desc",
		render: (item) => (
			<div style={{ fontSize: "13px", fontWeight: 400 }}>
				{item || ""}
			</div>
		),
	},
];

export default columns;
